import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CustomerPortalCreatePortalUserMutationVariables = Types.Exact<{
  input: Types.CreatePortalUserInput;
  tenantId: Types.Scalars['String']['input'];
}>;


export type CustomerPortalCreatePortalUserMutation = { __typename?: 'Mutation', customerPortalCreatePortalUser: { __typename?: 'PortalUserPayload', portalUser?: { __typename?: 'PortalUserDocument', id: string, portalUserId: string, tenantId: string, customerId: string, email: string, firstName: string, lastName: string, role: string, status: number, userType: Types.UserType, createdBy: string, createdDate: Types.TDateISO, lastModified: Types.TDateISO } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CustomerPortalUpdatePortalUserMutationVariables = Types.Exact<{
  input: Types.UpdatePortalUserInput;
  tenantId: Types.Scalars['String']['input'];
}>;


export type CustomerPortalUpdatePortalUserMutation = { __typename?: 'Mutation', customerPortalUpdatePortalUser: { __typename?: 'PortalUserPayload', portalUser?: { __typename?: 'PortalUserDocument', id: string, portalUserId: string, tenantId: string, customerId: string, email: string, firstName: string, lastName: string, role: string, status: number, userType: Types.UserType, createdBy: string, createdDate: Types.TDateISO, lastModified: Types.TDateISO } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CustomerPortalDeactivatePortalUserMutationVariables = Types.Exact<{
  input: Types.DeactivatePortalUserInput;
  tenantId: Types.Scalars['String']['input'];
}>;


export type CustomerPortalDeactivatePortalUserMutation = { __typename?: 'Mutation', customerPortalDeactivatePortalUser: { __typename?: 'PortalUserPayload', portalUser?: { __typename?: 'PortalUserDocument', id: string, portalUserId: string, tenantId: string, customerId: string, email: string, firstName: string, lastName: string, role: string, status: number, userType: Types.UserType, createdBy: string, createdDate: Types.TDateISO, lastModified: Types.TDateISO } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const CustomerPortalCreatePortalUserDocument = new TypedDocumentString(`
    mutation CustomerPortalCreatePortalUser($input: CreatePortalUserInput!, $tenantId: String!) {
  customerPortalCreatePortalUser(input: $input, tenantId: $tenantId) {
    portalUser {
      ...PortalUserFields
    }
    errors {
      code
      message
    }
  }
}
    fragment PortalUserFields on PortalUserDocument {
  id
  portalUserId
  tenantId
  customerId
  email
  firstName
  lastName
  role
  status
  userType
  createdBy
  createdDate
  lastModified
}`);
export const CustomerPortalUpdatePortalUserDocument = new TypedDocumentString(`
    mutation CustomerPortalUpdatePortalUser($input: UpdatePortalUserInput!, $tenantId: String!) {
  customerPortalUpdatePortalUser(input: $input, tenantId: $tenantId) {
    portalUser {
      ...PortalUserFields
    }
    errors {
      code
      message
    }
  }
}
    fragment PortalUserFields on PortalUserDocument {
  id
  portalUserId
  tenantId
  customerId
  email
  firstName
  lastName
  role
  status
  userType
  createdBy
  createdDate
  lastModified
}`);
export const CustomerPortalDeactivatePortalUserDocument = new TypedDocumentString(`
    mutation CustomerPortalDeactivatePortalUser($input: DeactivatePortalUserInput!, $tenantId: String!) {
  customerPortalDeactivatePortalUser(input: $input, tenantId: $tenantId) {
    portalUser {
      ...PortalUserFields
    }
    errors {
      code
      message
    }
  }
}
    fragment PortalUserFields on PortalUserDocument {
  id
  portalUserId
  tenantId
  customerId
  email
  firstName
  lastName
  role
  status
  userType
  createdBy
  createdDate
  lastModified
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CustomerPortalCreatePortalUser: build.mutation<CustomerPortalCreatePortalUserMutation, CustomerPortalCreatePortalUserMutationVariables>({
      query: (variables) => ({ document: CustomerPortalCreatePortalUserDocument, variables })
    }),
    CustomerPortalUpdatePortalUser: build.mutation<CustomerPortalUpdatePortalUserMutation, CustomerPortalUpdatePortalUserMutationVariables>({
      query: (variables) => ({ document: CustomerPortalUpdatePortalUserDocument, variables })
    }),
    CustomerPortalDeactivatePortalUser: build.mutation<CustomerPortalDeactivatePortalUserMutation, CustomerPortalDeactivatePortalUserMutationVariables>({
      query: (variables) => ({ document: CustomerPortalDeactivatePortalUserDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCustomerPortalCreatePortalUserMutation, useCustomerPortalUpdatePortalUserMutation, useCustomerPortalDeactivatePortalUserMutation } = injectedRtkApi;
